import { render } from "./dashboard.vue?vue&type=template&id=ad7169f2&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=ad7169f2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7169f2"]])

export default __exports__